
import BaseComponent from '../BaseComponent';

class Radio extends BaseComponent{
    
    constructor(aElement){
        
        super(aElement);
        
        this.name = this.element.data('name');

        this.value = this.element.find('INPUT[type="radio"]');
        
        this.all = $('.snookfun-form-radio[data-name='+this.name+']');

        this.attachEvents();
        
    }
    
    attachEvents(){
        
        this.element.on('click', (event)=>{

            this.all.removeClass('selected');
            
            this.element.addClass('selected');
                        
            this.all.find('INPUT[type="radio"]').removeAttr("checked");
                        
            this.value.attr("checked", "checked");
            
            this.onChange(this.value.attr('name'),this.value.val());
            
        });

    }
    
}

export default Radio;